import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ArrowIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4141 7.99993L5.70696 0.292818L4.29274 1.70703L10.5856 7.99993L4.29274 14.2928L5.70696 15.707L13.4141 7.99993Z",
        fill: "#0661EC"
      })
    })
  );
}